import React, { useEffect, useState } from "react";
import { Link,useLocation } from "react-router-dom";
import colors from "../constants/colors";
import { FaUserGraduate } from "react-icons/fa";
import studentId from "../config";
import axios from "axios";

const Navbar = ({ toggleSidebar }) => {
  
    const location = useLocation();
  const [notificationCount, setNotificationCount] = useState(0);
  const [profilePic, setProfilePic] = useState("");
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const routeTitles = {
    "/student/dashboard": "Dashboard",
    "/student-homework":"Homework",
     "/test-schedule":"Test Schedule",
     "/notifications-announcements":"Student Notification",
     "/student-achievement":" Student Achievements","/event-activities":"Events",
     "/aboutschool":"About School","/student/profile":"Profile",
     "/student-attendance":"Attandance",
     "/school-timetable":"TimeTable","/school-achievement":"School Achievemenet",
     "/student/courses":"Courses","/course-materials":"Course Material",
     "/subjects":"Subjects",
     "/student-assignments":"Assignments",
     "/student/examresults":"Exam Results","/exam-datesheet":"Datesheet","/exam-result":"Result",
     "/exam-paper":"Paper","/student/feemanagement":"Fee Management","/fee-structure":"Fee Structure",
     "/pending-fee":"Ledger","/student/support":"Support",

  };
  const pageTitle = routeTitles[location.pathname] || "";
  // Close dropdown if clicked outside
  useEffect(() => {
    const closeDropdown = (e) => {
      if (!e.target.closest(".profile-dropdown")) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  // Load notifications for current session + student
 useEffect(() => {
  const loadNotifications = async () => {
    try {
      // 1️⃣ Fetch student info
      const studentRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`
      );
      const student = studentRes.data;
      const sessionId = localStorage.getItem("currentSessionId");
      const role = "students"; // Or student.usertype

      // 2️⃣ Fetch general notifications
      const generalRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/notifications/getNotification`,
        { params: { sessionId, role, userId: student._id } }
      );
      const generalNotifications = generalRes.data || [];

      // 3️⃣ Fetch classwise notifications
      let classNotifications = [];
      if (student.classId && student.sectionId) {
        const classRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/getNotificationsByClassAndSection/${student.classId}/${student.sectionId}`,
          { params: { sessionId } }
        );
        classNotifications = classRes.data || [];
      }

      // 4️⃣ Combine notifications
      const allNotifications = [...generalNotifications, ...classNotifications];
      setNotificationCount(allNotifications.length);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  loadNotifications();
}, []);
 // Load student profile
  useEffect(() => {
    const loadProfile = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`
        );
        const data = response.data; 
        setProfilePic(data?.profileImage || "");
        setUserName(data?.firstName || "User");
        setUserRole(data?.usertype || "Student");
      } catch (error) {
        console.error("Error loading profile:", error);
      }
    };
    loadProfile();
  }, []);

  const handleNotificationClick = () => setNotificationCount(0);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  };

  return (
    <nav
      className="p-4 flex justify-between items-center shadow-lg"
      style={{
        background: colors.gradientPrimary,
        color: colors.primaryText,
      }}
    >
      {/* LEFT SECTION — Student Panel */}
      <div className="flex items-center space-x-3">
        <FaUserGraduate className="text-white h-7 w-7" />
        <h2 className="text-xl font-bold text-white">Student Panel</h2>
      </div>
    <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2">
        <h1 className="text-white text-xl font-semibold truncate max-w-xs text-center">
          {pageTitle}
        </h1>
      </div>
      {/* RIGHT SECTION */}
      <div className="flex items-center space-x-6">
        {/* Notifications */}
        <Link
          to="/notifications-announcements"
          className="relative text-white"
          onClick={handleNotificationClick}
        >
          <i className="fas fa-bell text-2xl hover:text-yellow-300 transition relative">
            {notificationCount > 0 && (
              <div className="absolute -top-1 -right-2 w-4 h-4 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow-lg">
                {notificationCount}
              </div>
            )}
          </i>
        </Link>

        {/* Profile Image + Dropdown */}
        <div className="relative profile-dropdown">
          <div
            className="flex items-center space-x-3 cursor-pointer"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {profilePic ? (
              <img
                src={profilePic}
                alt="Profile"
                className="w-12 h-12 rounded-full border-2 border-white object-cover hover:opacity-90"
              />
            ) : (
              <i className="fas fa-user-circle text-4xl text-white"></i>
            )}

            <div className="flex flex-col text-white leading-tight">
              <span className="text-xs font-semibold">Welcome, {userName}</span>
              <span className="text-xs opacity-80">{userRole}</span>
            </div>
          </div>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-1 w-30 bg-white shadow-lg rounded-md py-2 z-50">
              <Link
                to="/view-profile"
                className="block text-sm px-3 py-1 text-black hover:bg-gray-100"
                onClick={() => setIsDropdownOpen(false)}
              >
                View Profile
              </Link>

              <button
                onClick={() => {
                  setIsDropdownOpen(false);
                  handleLogout();
                }}
                className="block text-sm w-full text-left px-3 py-1 text-black hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button onClick={toggleSidebar} className="text-white md:hidden ml-2">
          <i className="fas fa-bars text-3xl"></i>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
